// @flow
import { Endpoints } from 'UI/constants/endpoints';

import { JSON_SCHEMA_CLIENT } from './API';

export const getJsonSchema = async (schemaName: string) => {
  return JSON_SCHEMA_CLIENT.get(`${Endpoints.JSONSchema.replace(':schemaName', schemaName)}`);
};
